import Vue from 'vue'
import App from './App.vue'
import store from './store'
import axios from 'axios'

import {config} from './config'


Vue.config.productionTip = false

console.log('Ver. ' + config.VERSION)


axios.interceptors.response.use(
	undefined,
	error => {
		if (error.response && error.response.status == 401) {
			store.commit('RESET_AUTH')
		}

		//console.log('Got error: ', error)
		
		const code = error.response && error.response.data && error.response.data.status || 'network'
		store.dispatch('showMessage', {
			status: 'error',
			code,
			//message: error && error.response && error.response.data && error.response.data.message
		})


		
		return error.response || null;
	}
)







new Vue({
	store,
	render: h => h(App)
}).$mount('#app')
